module.exports = __webpack_public_path__ + "static/media/just-for-quacks.c12a71f9.png";